import { styled } from "@mui/material/styles";
import { Drawer, LinearProgress, Stack } from "@mui/material";

export const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: "100%",
    maxWidth: "600px",
    overflow: "hidden",
  },
});

const inlineInputSx = (theme) => ({
  ".MuiFormControl-root": {
    ".MuiTypography-inputLabelSmall": {
      display: "none",
    },
    ".MuiInputBase-root, input, fieldset, textarea": {
      border: "0px",
    },
    "input, fieldset, textarea": {
      backgroundColor: "transparent",
    },
    ".MuiInputBase-root": {
      padding: "2px 0",
      border: "0px",
      borderBottom: `1px solid transparent`,
      borderRadius: 0,
      backgroundColor: "transparent",
      transition: "border-color 0.15s",
      "&:hover, &.Mui-focused": {
        borderBottom: `1px solid ${theme.palette.hubColors.greyMid}`,
      },
      ".MuiSvgIcon-root": {
        width: 12,
        height: 12,
      },
      ".MuiSelect-icon": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: 500,
        color: theme.palette.hubColors.greyDark2,
        fontSize: "12px",
        lineHeight: "12px",
      },
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        padding: "0 !important",
      },
    },
    ".MuiAutocomplete-root": {
      width: "100%",
      padding: 0,
      ".MuiInputBase-root": {
        paddingRight: "4px !important",
      },
    },
  },
});

export const StyledInfoGrid = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  borderRadius: 8,
  overflow: "hidden",
  "& > *": {
    padding: "10px 14px",
    borderRight: `1px solid ${theme.palette.hubColors.greyLight}`,
    "&:last-child": { borderRight: "none" },
  },
  ...inlineInputSx(theme),
}));

export const StyledInlineFields = styled(Stack)(({ theme }) => ({
  ...inlineInputSx(theme),
}));

export const StyledProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: theme.palette.hubColors.greyLight,
  "& .MuiLinearProgress-bar": {
    borderRadius: 4,
  },
}));

export const StyledTimeline = styled(Stack)({
  gap: 0,
  position: "relative",
  paddingLeft: 20,
  "&::before": {
    content: '""',
    position: "absolute",
    left: 7,
    top: 8,
    bottom: 8,
    width: 2,
    borderRadius: 1,
    backgroundColor: "rgba(0,0,0,0.08)",
  },
});

export const StyledTimelineItem = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: 10,
  padding: "8px 0",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    left: -17,
    top: 14,
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.hubColors.mainFocus,
  },
}));

export const StyledNoteCard = styled(Stack)(({ theme }) => ({
  padding: "12px 14px",
  borderRadius: 8,
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  gap: 6,
}));
